import client from "api/WookAxios";
import { parseErrors } from "lib/errors/parse";
import log from "loglevel";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const InvitePage = () => {
  const [searchParams] = useSearchParams();
  const invite_token = searchParams.get('token');
  
  const go = async () => {
    const data = {
      username: 'invite_test',
      password: '1234',
      password2: '1234',
      name: '초대인',
      mobile: '010-1111-2222',
      invite_token,
    };

    try {
      const response = client.invite(data);
      log.debug('INVITE_SUCCESS', response);
    } catch(e) {
      log.debug('INVITE_FAILED', e);
      const errors = parseErrors(e.response);
      log.debug(errors[0].message);
    }
  };

  const handleGo = () => {
    go();
  };

  return(
    <div className="InvitePage">
      <button onClick={handleGo}>go</button>
    </div>
  );
};